import { Box, Flex, Text, Tooltip } from '@chakra-ui/react'
import { useTranslation } from 'next-i18next/pages'
import { ReactNode } from 'react'
import { AiOutlineInfoCircle } from 'react-icons/ai'

interface GameInfoProps {
  rtp: string
  maxWin?: ReactNode
  winningFee?: string
  force?: boolean
  variant?: 'compact' | 'full'
}

export const GameInfo = ({ rtp, force, maxWin, winningFee, variant = 'compact' }: GameInfoProps) => {
  const { t } = useTranslation()

  if (variant === 'compact') {
    return (
      <Flex gap={3} fontSize={'2xs'} alignItems={'center'} justifyContent={'space-between'} opacity={0.6}>
        <Flex gap={1} alignItems={'center'}>
          <Text color={'ninja.200'} fontWeight={400}>
            {t('game-info.rtp')}:
          </Text>
          <Text color={'ninja.100'} fontWeight={500}>
            {rtp}
          </Text>
        </Flex>
        {maxWin && (
          <Tooltip
            label={t('game-info.max-win-tooltip')}
            fontSize={'xs'}
            color={'ninja.100'}
            bg={'ninja.500'}
            rounded={'lg'}
            p={2}
            maxW={'220px'}
            hasArrow
          >
            <Flex gap={1} alignItems={'center'} cursor={'help'}>
              <Text color={'ninja.200'} fontWeight={400}>
                {t('game-info.max-win')}:
              </Text>
              <Box as={AiOutlineInfoCircle} color={'ninja.300'} flexShrink={0} />
              <Text color={'ninja.100'} fontWeight={500}>
                {maxWin}
              </Text>
            </Flex>
          </Tooltip>
        )}
        {winningFee && (
          <Flex gap={1} alignItems={'center'}>
            <Text color={'ninja.200'} fontWeight={400}>
              {t('game-info.winning-fee')}:
            </Text>
            <Text color={'ninja.100'} fontWeight={500}>
              {winningFee}
            </Text>
          </Flex>
        )}
      </Flex>
    )
  }

  return (
    <Box
      bg={'rgba(142, 131, 251, 0.1)'}
      border={'1px solid'}
      borderColor={'rgba(142, 131, 251, 0.3)'}
      rounded={'xl'}
      p={4}
    >
      <Flex gap={3} flexDir={'column'}>
        <Flex justifyContent={'space-between'} alignItems={'center'}>
          <Text fontSize={'sm'} color={'ninja.100'} fontWeight={500}>
            {t('game-info.rtp')}
          </Text>
          <Text fontSize={'md'} color={'white'} fontWeight={700}>
            {rtp}
          </Text>
        </Flex>
        {maxWin && (
          <Flex justifyContent={'space-between'} alignItems={'center'}>
            <Tooltip
              label={t('game-info.max-win-tooltip')}
              fontSize={'xs'}
              color={'ninja.100'}
              bg={'ninja.500'}
              rounded={'lg'}
              p={2}
              maxW={'220px'}
              hasArrow
            >
              <Flex gap={1} alignItems={'center'} cursor={'help'}>
                <Text fontSize={'sm'} color={'ninja.100'} fontWeight={500}>
                  {t('game-info.max-win')}
                </Text>
                <Box as={AiOutlineInfoCircle} color={'ninja.300'} flexShrink={0} />
              </Flex>
            </Tooltip>
            <Text fontSize={'md'} color={'white'} fontWeight={700}>
              {maxWin}
            </Text>
          </Flex>
        )}
        {winningFee && (
          <Flex justifyContent={'space-between'} alignItems={'center'}>
            <Text fontSize={'sm'} color={'ninja.100'} fontWeight={500}>
              {t('game-info.winning-fee')}
            </Text>
            <Text fontSize={'md'} color={'white'} fontWeight={700}>
              {winningFee}
            </Text>
          </Flex>
        )}
      </Flex>
    </Box>
  )
}
